 <template>
    <el-cascader
        ref="cascader"
        @change="SelectChange"
        v-model="selectValue"
        :options="select"
        :props="{ label: 'name', value: 'id', emitPath: false }"
        :style="{ width: width, margin: margin }"
        :disabled="disabled"
        placeholder="请选择所在区域"
        size="mini"
        clearable
        filterable>
    </el-cascader>
</template>
<script>
export default {
    props: {
        value: {
            type: [Number, String, Array],
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '100%'
        },
        margin: {
            type: String,
            default: '0px'
        }
    },
    watch: {
        value: {
            handler(val) {
                this.selectValue = val
            },
            immediate: true
        }
    },
    data () {
        return {
            select: [],
            selectValue: null,
        }
    },
    mounted () {
        this.$http.post('/9api/config/country/cascader').then(rps => {
            this.select = rps.data
            this.selectValue = this.value
        })
    },
    methods: {
        SelectChange(data) {
            this.$emit('input', data)
            this.$emit('onChange', this.$refs.cascader.getCheckedNodes()[0].data)
        }
    }
}
</script>